var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 3C22.92 3 24 4.08 24 5.4V24L20.4 21H2.6C1.28 21 0 20.12 0 18.8V5.4C0 4.08 1.08 3 2.4 3H21.6ZM13.2005 13.2H16.8005C17.4605 13.2 18.0005 12.66 18.0005 12C18.0005 11.34 17.4605 10.8 16.8005 10.8H13.2005V7.2C13.2005 6.54 12.6605 6 12.0005 6C11.3405 6 10.8005 6.54 10.8005 7.2V10.8H7.20049C6.54049 10.8 6.00049 11.34 6.00049 12C6.00049 12.66 6.54049 13.2 7.20049 13.2H10.8005V16.8C10.8005 17.46 11.3405 18 12.0005 18C12.6605 18 13.2005 17.46 13.2005 16.8V13.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddComment);
export default __webpack_public_path__ + "static/media/add_comment.604dae8f.svg";
export { ForwardRef as ReactComponent };